import jspdf from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import "@/assets/fonts/Roboto-Regular-normal.js";
import store from "./state/store";
import axios from "axios";
// import i18n from "./i18n";
import NumberFormatter from "./numberFormatter";
const i18n = NumberFormatter.shared;

var QRCode = require("qrcode");
export default {
  convertToWords(number) {
    let words = "";
    let units = [
      "",
      "jedan",
      "dva",
      "tri",
      "četiri",
      "pet",
      "šest",
      "sedam",
      "osam",
      "devet",
    ];
    let tens = [
      "",
      "deset",
      "dvadeset",
      "trideset",
      "četrdeset",
      "pedeset",
      "šezdeset",
      "sedamdeset",
      "osamdeset",
      "devedeset",
    ];
    let teen = [
      "deset",
      "jedanaest",
      "dvanaest",
      "trinaest",
      "četrnaest",
      "petnaest",
      "šesnaest",
      "sedamnaest",
      "osamnaest",
      "devetnaest",
    ];
    let sections = ["", "hiljada", "milion"];

    let decimal = 0;
    if (!Number.isInteger(number)) {
      decimal = number.toString().split(".")[1];
      number = Math.floor(number);
    }

    let section = 0;
    do {
      let chunk = number % 1000;
      if (chunk) {
        if (section > 0) {
          words = sections[section] + " " + words;
        }
        let chunkWords = "";
        let chunkUnits = chunk % 10;
        chunk = Math.floor(chunk / 10);
        let chunkTens = chunk % 10;
        chunk = Math.floor(chunk / 10);
        let chunkHundreds = chunk % 10;
        if (chunkHundreds > 0) {
          chunkWords += units[chunkHundreds] + " stotina ";
        }
        if (chunkTens > 1) {
          chunkWords += tens[chunkTens] + " ";
        } else if (chunkTens === 1) {
          chunkWords += teen[chunkUnits] + " ";
          chunkUnits = 0;
        }
        if (chunkUnits > 0) {
          chunkWords += units[chunkUnits] + " ";
        }
        words = chunkWords + words;
      }
      number = Math.floor(number / 1000);
      section++;
    } while (number > 0);

    if (decimal > 0) {
      words += "i " + decimal + "/100";
    }

    return words.trim();
  },
  generate_invoice_pdf(invoice, print_pecat, print_potpis, is_offer) {
    return new Promise((resolve, reject) => {
      try {
        var signature = invoice.signature;
        var logo = invoice.logo;
        var stamp = invoice.stamp;
        const doc = new jspdf({
          orientation: "p",
          unit: "mm",
          format: "a4",
          putOnlyUsedFonts: true,
        });
        var header_start = 5;
        if (logo !== null) {
          var i_width = doc.getImageProperties(logo).width;
          var i_height = doc.getImageProperties(logo).height;
          var i_aspect = i_width / i_height;
          i_width = 11 * i_aspect;
          doc.addImage(logo, "JPEG", 10, 10, i_width, 11);
          header_start += i_width + 10;
        }
        doc.setFont("Roboto-Regular");
        doc.setFontSize(9);
        if (invoice.document_header !== null) {
          doc.text(invoice.document_header, header_start, 13);
        }
        // end header
        doc.setFontSize(10);
        doc.text(invoice.naziv.toString(), 10, 35);
        doc.text(
          invoice.adresa != null ? invoice.adresa.toString() : null,
          10,
          40
        );
        doc.text(invoice.opstina.toString() + ", " + invoice.drzava, 10, 45);
        if (invoice.idbroj > 0)
          doc.text("ID Broj: " + invoice.idbroj.toString(), 10, 50);
        if (invoice.pdvbroj > 0)
          doc.text("PDV Broj: " + invoice.pdvbroj.toString(), 10, 55);
        doc.text(is_offer ? "Broj ponude:" : "Broj računa:", 100, 35);
        doc.text(invoice.broj.toString(), 145, 35);
        if (!is_offer) doc.text("Broj fiskalnog računa:", 100, 40);
        if (!is_offer && invoice.fiskalni_broj !== 0)
          doc.text(invoice.fiskalni_broj.toString(), 145, 40);
        doc.text(is_offer ? "Datum ponude" : "Datum računa: ", 100, 45);
        doc.text(
          moment(new Date(invoice.datum_kreiranja))
            .format("Do MMMM YYYY")
            .toString() + ". god.",
          145,
          45
        );
        doc.text(
          is_offer ? "Mjesto izdavanja ponude:" : "Mjesto izdavanja računa:",
          100,
          50
        );
        doc.text(invoice.account_city, 145, 50);
        if (!is_offer) {
          doc.text("Broj ugovora:", 100, 55);
          doc.text(
            invoice.ugovor_referenca !== null
              ? invoice.ugovor_referenca.toString()
              : "-",
            145,
            55
          );
        }
        doc.autoTable({
          startY: 65,
          tableLineWidth: 0.2,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 11,
            fillColor: [240, 240, 240],
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "center", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text: is_offer
                ? this.grand_total(invoice) > 0
                  ? "Ponuda se smatra važećom do " +
                  this.uplatiti_do_formatiran(invoice) +
                  ". god."
                  : invoice.napomena
                : this.grand_total(invoice) > 0
                  ? "RAČUN BROJ: " + invoice.broj
                  : invoice.napomena,
            },
          ],
        });
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 5,
          tableLineWidth: 0.15,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "lastPage",
          columnStyles: {
            0: { halign: "center", valign: "top", cellWidth: 8 },
            1: { halign: "left", valign: "top", cellWidth: 70 },
            2: { halign: "center", valign: "top" },
            3: { halign: "center", valign: "top" },
            4: { halign: "right", valign: "top", cellWidth: 23 },
            5: { halign: "center", valign: "top", cellWidth: 13 },
            6: { halign: "right", valign: "top", cellWidth: 23 },
            7: { halign: "right", valign: "top", cellWidth: 23 },
          },
          margin: { top: 10, left: 10, right: 10, bottom: 30 },
          head: [
            [
              {
                content: "#",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Naziv i opis usluge/robe",
                styles: {
                  halign: "left",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "JM",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Kol",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Cijena/JM bez PDV-a",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "PDV %",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "PDV",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Ukupno bez PDV-a",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
            ],
          ],
          body: invoice.artikli.map((x, index) => {
            return [
              (index + 1).toString(),
              x.naziv.toString() + "\n" + x.opis.toString(),
              x.jedinica_mjere.toString(),
              i18n.n(parseFloat(x.kom).toFixed(2)),
              x.rabat > 0
                ? i18n.n(parseFloat(x.cijena_rabat).toFixed(2))
                : i18n.n(parseFloat(x.cijena, 2).toFixed(2)),
              Math.round(x.pdv_postotak).toString() + "%",
              i18n.n(parseFloat(x.pdv_total, 2).toFixed(2)),
              i18n.n(parseFloat(x.ukupno, 2).toFixed(2)),
            ];
          }),
        });
        var footer_start_position = doc.autoTable.previous.finalY;
        var is_new_page = false;
        if (footer_start_position > 230) {
          is_new_page = true;
          doc.addPage();
          footer_start_position = 20;
        }
        doc.autoTable({
          startY: footer_start_position + 1,
          tableLineWidth: 0,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0,
            fontSize: 9,
          },
          showFoot: "never",
          columnStyles: {
            0: { halign: "right", valign: "middle" },
            1: { halign: "right", valign: "middle" },
            2: { halign: "right", valign: "middle" },
          },
          theme: "plain",
          margin: {
            top: is_new_page ? 10 : 20,
            left: 145,
            right: 10,
            bottom: 30,
          },
          body: [
            [
              {
                content: "Ukupno bez PDV-a",
                styles: {
                  halign: "right",
                },
              },
              i18n.n(parseFloat(this.invoice_total(invoice)).toFixed(2)),
            ],
            [
              {
                content: "PDV",
                styles: {
                  halign: "right",
                },
              },
              i18n.n(parseFloat(this.tax_total(invoice)).toFixed(2)),
            ],
            [
              {
                content: "Za uplatiti",
                styles: {
                  halign: "right",
                  cellWidth: "wrap",
                  lineWidth: {
                    top: 0.2,
                    botom: 0.2,
                  },
                  lineColor: [0, 0, 0],
                  fillColor: [240, 240, 240],
                },
              },
              {
                content:
                  "KM   " +
                  i18n.n(parseFloat(this.grand_total(invoice)).toFixed(2)),
                styles: {
                  halign: "right",
                  lineWidth: {
                    top: 0.2,
                    botom: 0.2,
                  },
                  lineColor: [0, 0, 0],
                  fillColor: [240, 240, 240],
                },
              },
            ],
          ],
        });
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 2,
          tableLineWidth: 0,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0,
            fontSize: 9,
          },
          columnStyles: {
            0: { halign: "left", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          theme: "plain",
          body: [
            [
              {
                content:
                  "Slovima: " +
                  this.convertToWords(
                    parseFloat(this.grand_total(invoice)).toFixed(2)
                  ) +
                  ".",
                styles: {
                  halign: "left",
                  valign: "middle",
                  cellWidth: "auto",
                },
              },
            ],
          ],
        });
        if (invoice.artikli.filter((x) => x.rabat > 0).length) {
          doc.autoTable({
            startY: doc.autoTable.previous.finalY + 3,
            rowPageBreak: "avoid",
            tableLineWidth: 0.15,
            styles: {
              font: "Roboto-Regular",
              lineWidth: 0.15,
              fontSize: 9,
            },
            theme: "plain",
            showFoot: "never",
            columnStyles: {
              0: { halign: "left", valign: "middle" },
              1: { halign: "right", valign: "middle", cellWidth: 25 },
              2: { halign: "center", valign: "middle", cellWidth: 15 },
              3: { halign: "right", valign: "middle", cellWidth: 25 },
              4: { halign: "right", valign: "middle", cellWidth: 25 },
              5: { halign: "center", valign: "middle", cellWidth: 15 },
              6: { halign: "right", valign: "middle", cellWidth: 25 },
            },
            margin: { top: 0, left: 10, right: 10, bottom: 40 },
            head: [
              [
                {
                  content: "Naziv i opis usluge/robe",
                  styles: {
                    halign: "left",
                    valign: "middle",
                    fillColor: [240, 240, 240],
                    textColor: [0, 0, 0],
                  },
                },
                {
                  content: "Cijena",
                  styles: {
                    halign: "center",
                    valign: "middle",
                    cellWidth: "wrap",
                    fillColor: [240, 240, 240],
                    textColor: [0, 0, 0],
                  },
                },
                {
                  content: "Rabat",
                  styles: {
                    halign: "center",
                    valign: "middle",
                    fillColor: [240, 240, 240],
                    textColor: [0, 0, 0],
                    cellWidth: "wrap",
                  },
                },
                {
                  content: "Cijena-Rabat",
                  styles: {
                    halign: "center",
                    valign: "middle",
                    fillColor: [240, 240, 240],
                    textColor: [0, 0, 0],
                    cellWidth: "wrap",
                  },
                },
                {
                  content: "Razlika",
                  styles: {
                    cellWidth: "auto",
                    halign: "center",
                    valign: "middle",
                    fillColor: [240, 240, 240],
                    textColor: [0, 0, 0],
                  },
                },
                {
                  content: "Količina",
                  styles: {
                    halign: "center",
                    valign: "middle",
                    fillColor: [240, 240, 240],
                    textColor: [0, 0, 0],
                  },
                },
                {
                  content: "Ušteda",
                  styles: {
                    halign: "center",
                    valign: "middle",
                    fillColor: [240, 240, 240],
                    textColor: [0, 0, 0],
                  },
                },
              ],
            ],
            body: invoice.artikli
              .filter((p) => p.rabat > 0)
              .map((x) => {
                return [
                  x.naziv.toString(),
                  i18n.n(parseFloat(x.cijena).toFixed(2)),
                  i18n.n(parseFloat(x.rabat).toFixed(2)) + "%",
                  i18n.n(parseFloat(x.cijena_rabat).toFixed(2)),
                  i18n.n(parseFloat(x.cijena_rabat - x.cijena).toFixed(2)),
                  i18n.n(parseFloat(x.kom).toFixed(2)),
                  i18n.n(
                    parseFloat((x.cijena_rabat - x.cijena) * x.kom).toFixed(2)
                  ),
                ];
              }),
          });
        }
        footer_start_position = doc.autoTable.previous.finalY;
        if (footer_start_position > 230) {
          doc.addPage();
          footer_start_position = 20;
        }
        doc.autoTable({
          startY: footer_start_position,
          tableLineWidth: 0,
          margin: { top: 0, left: 10, right: 10 },
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0,
            fontSize: 9,
          },
          theme: "plain",
          columnStyles: {
            0: { fillColor: [255, 255, 255], fontStyle: "bold" },
          },
          body: [
            [
              !is_offer
                ? "Način plaćanja: " + " " + invoice.payment_type + "."
                : "",
            ],
            [
              typeof invoice.payment_info !== "undefined" &&
                invoice.payment_info !== null
                ? "Informacije za plaćanje računa: " +
                invoice.payment_info.replace(
                  /#faktura#/g,
                  invoice.broj.toString()
                ) +
                "."
                : "",
            ],
            [
              invoice.napomena !== null
                ? "Napomena: " + invoice.napomena.toString()
                : "",
            ],
          ],
        });
        var c_y_positions = [];
        if (print_pecat && stamp !== null) {
          var s_width = doc.getImageProperties(stamp).width;
          var s_height = doc.getImageProperties(stamp).height;
          var s_aspect = s_width / s_height;
          s_width = 30 * s_aspect;
          doc.addImage(
            stamp,
            "png",
            78,
            doc.autoTable.previous.finalY + 1,
            s_width,
            30,
            "pecat"
          );
          c_y_positions.push(doc.autoTable.previous.finalY + 40);
        }
        doc.text("M.P", 95, doc.autoTable.previous.finalY + 6);

        if (print_potpis && signature !== null) {
          var p_width = doc.getImageProperties(signature).width;
          var p_height = doc.getImageProperties(signature).height;
          var p_aspect = p_width / p_height;
          p_width = 12 * p_aspect;
          doc.addImage(
            signature,
            "png",
            135,
            doc.autoTable.previous.finalY + 3,
            p_width,
            12
          );
          c_y_positions.push(doc.autoTable.previous.finalY + 32);
        }

        doc.text(
          "______________________________",
          145,
          doc.autoTable.previous.finalY + 13
        );
        doc.text(
          typeof invoice_account_signatory !== "undefined" &&
            invoice.account_signatory !== null
            ? invoice.account_signatory
            : "",
          145,
          doc.autoTable.previous.finalY + 30
        );
        var max_y = 0;
        c_y_positions.forEach((p) => {
          if (p > max_y) max_y = parseInt(p);
        });

        if (max_y == 0) {
          max_y = doc.autoTable.previous.finalY + 30;
        } else {
          max_y += 5;
        }
        var numOfPages = doc.internal.getNumberOfPages();
        for (var i = 1; i <= numOfPages; i++) {
          doc.setPage(i);
          var footer_start = 5;
          if (logo !== null) {
            var f_width = doc.getImageProperties(logo).width;
            var f_height = doc.getImageProperties(logo).height;
            var f_aspect = f_width / f_height;
            f_width = 7 * f_aspect;
            doc.addImage(logo, "JPEG", 10, 297 - 18, f_width, 7);
            footer_start += f_width + 10;
          }
          doc.setFontSize(8);
          doc.setTextColor(66, 75, 84);
          if (invoice.document_footer !== null) {
            doc.text(invoice.document_footer, footer_start, 297 - 17);
          }

          if (is_offer) {
            QRCode.toDataURL("Ponuda " + invoice.broj, function (err, url) {
              doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
            });
          } else {
            QRCode.toDataURL("Faktura " + invoice.broj, function (err, url) {
              doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
            });
          }

          doc.text(
            "Stranica " + String(i) + " od " + numOfPages,
            210 - 30,
            297 - 5
          );

          doc.setFontSize(6);
          doc.text(
            "Ovaj dokument je kreiran upotrebom SABIRA™ poslovne platforme. Za više informacija posjetite SABIRA.BA",
            10,
            297 - 5
          );
        }
        //var binary = doc.output();
        resolve({
          raw_doc: doc,
          filename: "faktura_" + invoice.broj + ".pdf",
          content: doc.output(),
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  generate_ko_pdf(ko, print_pecat, print_potpis) {
    return new Promise((resolve, reject) => {
      try {
        var signature = ko.signature;
        var logo = ko.logo;
        var stamp = ko.stamp;
        const doc = new jspdf({
          orientation: "p",
          unit: "mm",
          format: "a4",
          putOnlyUsedFonts: true,
        });
        // header start
        var header_start = 5;
        if (logo !== null) {
          var i_width = doc.getImageProperties(logo).width;
          var i_height = doc.getImageProperties(logo).height;
          var i_aspect = i_width / i_height;
          i_width = 11 * i_aspect;
          doc.addImage(logo, "JPEG", 10, 10, i_width, 11);
          header_start += i_width + 10;
        }
        doc.setFont("Roboto-Regular");
        doc.setFontSize(9);
        if (ko.document_header !== null) {
          doc.text(ko.document_header, header_start, 13);
        }
        // end header
        doc.setFontSize(10);
        doc.text(ko.naziv.toString(), 10, 35);
        doc.text(ko.adresa != null ? ko.adresa.toString() : null, 10, 40);
        doc.text(ko.opstina.toString() + ", " + ko.drzava, 10, 45);
        if (ko.idbroj > 0) doc.text("ID Broj: " + ko.idbroj.toString(), 10, 50);
        if (ko.pdvbroj > 0)
          doc.text("PDV Broj: " + ko.pdvbroj.toString(), 10, 55);
        doc.text("Broj knjižne obavijesti:", 100, 35);
        doc.text(ko.ko_number.toString(), 145, 35);
        doc.text("Reklamirani fisk. račun:", 100, 40);
        doc.text(ko.reklam_fiscal_number.toString(), 145, 40);
        doc.text("Faktura za koju se izdaje:", 100, 45);
        doc.text(ko.invoice_number.toString(), 145, 45);
        doc.text("Datum izdavanja: ", 100, 50);
        doc.text(
          moment(new Date(ko.ko_date))
            .format("Do MMMM YYYY")
            .toString() + ". god.",
          145,
          50
        );
        doc.text("Mjesto izdavanja:", 100, 55);
        doc.text(ko.account_city, 145, 55);

        doc.autoTable({
          startY: 62,
          tableLineWidth: 0.2,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 11,
            fillColor: [240, 240, 240],
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "center", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text:
                "KO broj " +
                ko.ko_number +
                " odobren za iznos " +
                i18n.n(parseFloat(this.grand_total_ko(ko)).toFixed(2)) +
                " KM",
            },
          ],
        });
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 5,
          tableLineWidth: 0.15,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "lastPage",
          columnStyles: {
            0: { halign: "center", valign: "top", cellWidth: 8 },
            1: { halign: "left", valign: "top", cellWidth: 70 },
            2: { halign: "center", valign: "top" },
            3: { halign: "center", valign: "top" },
            4: { halign: "right", valign: "top", cellWidth: 23 },
            5: { halign: "right", valign: "top", cellWidth: 13 },
            6: { halign: "right", valign: "top", cellWidth: 23 },
            7: { halign: "right", valign: "top", cellWidth: 23 },
          },
          margin: { top: 10, left: 10, right: 10, bottom: 30 },
          head: [
            [
              {
                content: "#",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Naziv i opis usluge/robe",
                styles: {
                  halign: "left",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "JM",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Kol",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Cijena/JM bez PDV-a",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "PDV %",
                styles: {
                  cellWidth: "auto",
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "PDV",
                styles: {
                  cellWidth: "auto",
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "Ukupno bez PDV-a",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
            ],
          ],
          body: ko.artikli.map((x, index) => {
            return [
              (index + 1).toString(),
              x.naziv.toString() + "\n" + x.opis.toString(),
              x.jedinica_mjere.toString(),
              x.kom.toString(),
              x.rabat > 0
                ? i18n.n(parseFloat(x.cijena_rabat).toFixed(2))
                : i18n.n(parseFloat(x.cijena).toFixed(2)),
              Math.round(x.pdv_postotak).toString() + "%",
              i18n.n(parseFloat(x.pdv_total).toFixed(2)),
              i18n.n(parseFloat(x.ukupno).toFixed(2)),
            ];
          }),
        });
        var footer_start_position = doc.autoTable.previous.finalY;
        var is_new_page = false;
        if (footer_start_position > 230) {
          is_new_page = true;
          doc.addPage();
          footer_start_position = 20;
        }
        doc.autoTable({
          startY: footer_start_position + 1,
          tableLineWidth: 0,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "never",
          columnStyles: {
            0: { halign: "left", valign: "middle" },
            1: { halign: "right", valign: "middle" },
            2: { halign: "right", valign: "middle", cellWidth: 30 },
          },
          margin: {
            top: is_new_page ? 10 : 20,
            left: 10,
            right: 10,
            bottom: 30,
          },
          body: [
            [
              "Slovima: " +
              this.convertToWords(
                parseFloat(this.grand_total_ko(ko)).toFixed(2)
              ),
              "Ukupno",
              i18n.n(parseFloat(this.ko_total(ko)).toFixed(2)),
            ],
            [
              {
                content: ko.ko_note !== null ? ko.ko_note.toString() : "",
                rowSpan: 2,
                styles: {
                  halign: "left",
                  valign: "top",
                  cellWidth: "auto",
                },
              },
              {
                content: "PDV",
                styles: {
                  halign: "right",
                },
              },
              i18n.n(parseFloat(this.tax_total(ko)).toFixed(2)),
            ],
            [
              {
                content: "Odobreni iznos",
                styles: {
                  halign: "right",
                  cellWidth: "wrap",
                  lineWidth: {
                    top: 0.3,
                    botom: 0.3,
                  },
                  lineColor: [0, 0, 0],
                },
              },
              {
                content:
                  "KM   " +
                  i18n.n(parseFloat(this.grand_total_ko(ko)).toFixed(2)),
                styles: {
                  halign: "right",
                  lineWidth: {
                    top: 0.3,
                    botom: 0.3,
                  },
                  lineColor: [0, 0, 0],
                },
              },
            ],
          ],
        });
        // if (ko.artikli.filter((x) => x.rabat > 0).length) {
        //   doc.autoTable({
        //     startY: doc.autoTable.previous.finalY + 5,
        //     rowPageBreak: "avoid",
        //     tableLineWidth: 0,
        //     styles: {
        //       font: "Roboto-Regular",
        //       lineWidth: 0.1,
        //       fontSize: 9,
        //     },
        //     showFoot: "never",
        //     columnStyles: {
        //       0: { halign: "left", valign: "middle" },
        //       1: { halign: "right", valign: "middle", cellWidth: 25 },
        //       2: { halign: "center", valign: "middle", cellWidth: 15 },
        //       3: { halign: "right", valign: "middle", cellWidth: 25 },
        //       4: { halign: "right", valign: "middle", cellWidth: 25 },
        //       5: { halign: "center", valign: "middle", cellWidth: 15 },
        //       6: { halign: "right", valign: "middle", cellWidth: 25 },
        //     },
        //     margin: { top: 0, left: 10, right: 10, bottom: 40 },
        //     head: [
        //       [
        //         {
        //           content: "Naziv i opis usluge/robe",
        //           styles: {
        //             halign: "left",
        //             valign: "middle",
        //             fillColor: [255, 255, 255],
        //             textColor: [0, 0, 0],
        //           },
        //         },
        //         {
        //           content: "Cijena",
        //           styles: {
        //             halign: "center",
        //             valign: "middle",
        //             cellWidth: "wrap",
        //             fillColor: [255, 255, 255],
        //             textColor: [0, 0, 0],
        //           },
        //         },
        //         {
        //           content: "Rabat",
        //           styles: {
        //             halign: "center",
        //             valign: "middle",
        //             fillColor: [255, 255, 255],
        //             textColor: [0, 0, 0],
        //             cellWidth: "wrap",
        //           },
        //         },
        //         {
        //           content: "Cijena-Rabat",
        //           styles: {
        //             halign: "center",
        //             valign: "middle",
        //             fillColor: [255, 255, 255],
        //             textColor: [0, 0, 0],
        //             cellWidth: "wrap",
        //           },
        //         },
        //         {
        //           content: "Razlika",
        //           styles: {
        //             cellWidth: "auto",
        //             halign: "center",
        //             valign: "middle",
        //             fillColor: [255, 255, 255],
        //             textColor: [0, 0, 0],
        //           },
        //         },
        //         {
        //           content: "Količina",
        //           styles: {
        //             halign: "center",
        //             valign: "middle",
        //             fillColor: [255, 255, 255],
        //             textColor: [0, 0, 0],
        //           },
        //         },
        //         {
        //           content: "Ušteda",
        //           styles: {
        //             halign: "center",
        //             valign: "middle",
        //             fillColor: [255, 255, 255],
        //             textColor: [0, 0, 0],
        //           },
        //         },
        //       ],
        //     ],
        //     body: ko.artikli
        //       .filter((p) => p.rabat > 0)
        //       .map((x) => {
        //         return [
        //           x.naziv.toString(),
        //           i18n.n(x.cijena),
        //           i18n.n(x.rabat) + "%",
        //           i18n.n(x.cijena_rabat),
        //           i18n.n(x.cijena_rabat - x.cijena),
        //           x.kom.toString(),
        //           i18n.n(
        //             parseFloat((x.cijena_rabat - x.cijena) * x.kom).toFixed(2)
        //           ),
        //         ];
        //       }),
        //   });
        // }
        footer_start_position = doc.autoTable.previous.finalY;
        if (footer_start_position > 265) {
          doc.addPage();
          footer_start_position = 20;
        }

        var c_y_positions = [];
        if (print_pecat && stamp !== null) {
          var s_width = doc.getImageProperties(stamp).width;
          var s_height = doc.getImageProperties(stamp).height;
          var s_aspect = s_width / s_height;
          s_width = 30 * s_aspect;
          doc.addImage(
            stamp,
            "png",
            78,
            doc.autoTable.previous.finalY + 10,
            s_width,
            30,
            "pecat"
          );
          c_y_positions.push(doc.autoTable.previous.finalY + 40);
        }
        doc.text("M.P", 95, doc.autoTable.previous.finalY + 15);

        if (print_potpis && signature !== null) {
          var p_width = doc.getImageProperties(signature).width;
          var p_height = doc.getImageProperties(signature).height;
          var p_aspect = p_width / p_height;
          p_width = 12 * p_aspect;
          doc.addImage(
            signature,
            "png",
            135,
            doc.autoTable.previous.finalY + 13,
            p_width,
            12
          );
          c_y_positions.push(doc.autoTable.previous.finalY + 32);
        }

        doc.text(
          "______________________________",
          145,
          doc.autoTable.previous.finalY + 25
        );
        doc.text(
          typeof invoice_account_signatory !== "undefined" &&
            ko.account_signatory !== null
            ? ko.account_signatory
            : "",
          145,
          doc.autoTable.previous.finalY + 30
        );
        var max_y = 0;
        c_y_positions.forEach((p) => {
          if (p > max_y) max_y = parseInt(p);
        });

        if (max_y == 0) {
          max_y = doc.autoTable.previous.finalY + 30;
        } else {
          max_y += 5;
        }
        var numOfPages = doc.internal.getNumberOfPages();
        for (var i = 1; i <= numOfPages; i++) {
          doc.setPage(i);
          var footer_start = 5;
          if (logo !== null) {
            var f_width = doc.getImageProperties(logo).width;
            var f_height = doc.getImageProperties(logo).height;
            var f_aspect = f_width / f_height;
            f_width = 7 * f_aspect;
            doc.addImage(logo, "JPEG", 10, 297 - 18, f_width, 7);
            footer_start += f_width + 10;
          }
          doc.setFontSize(8);
          doc.setTextColor(66, 75, 84);
          if (ko.document_footer !== null) {
            doc.text(ko.document_footer, footer_start, 297 - 17);
          }

          QRCode.toDataURL("KO broj " + ko.ko_number, function (err, url) {
            doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
          });

          doc.text(
            "Stranica " + String(i) + " od " + numOfPages,
            210 - 30,
            297 - 4
          );

          doc.setFontSize(6);
          doc.text(
            "Ovaj dokument je kreiran upotrebom SABIRA™ poslovne platforme. Za više informacija posjetite SABIRA.BA",
            10,
            297 - 4
          );
        }
        // var binary = doc.output();
        resolve({
          raw_doc: doc,
          filename: "faktura_" + ko.ko_number + ".pdf",
          content: doc.output(),
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  generate_order_pdf(order, print_pecat, print_potpis) {
    return new Promise((resolve, reject) => {
      try {
        var signature = order.signature;
        var stamp = order.stamp;
        var logo = order.logo;
        const doc = new jspdf({
          orientation: "p",
          unit: "mm",
          format: "a4",
          putOnlyUsedFonts: true,
        });
        // header start
        var header_start = 5;
        if (logo !== null) {
          var i_width = doc.getImageProperties(logo).width;
          var i_height = doc.getImageProperties(logo).height;
          var i_aspect = i_width / i_height;
          i_width = 11 * i_aspect;
          doc.addImage(logo, "JPEG", 10, 10, i_width, 11);
          header_start += i_width + 10;
        }
        doc.setFont("Roboto-Regular");
        doc.setFontSize(9);

        if (order.document_header !== null) {
          doc.text(order.document_header, header_start, 13);
        }
        // end header
        doc.setFontSize(10);
        doc.text(order.naziv.toString(), 10, 35);
        doc.text(order.adresa != null ? order.adresa.toString() : null, 10, 40);
        doc.text(order.opstina.toString() + ", " + order.drzava, 10, 45);
        if (order.idbroj > 0)
          doc.text("ID Broj: " + order.idbroj.toString(), 10, 50);
        if (order.pdvbroj > 0)
          doc.text("PDV Broj: " + order.pdvbroj.toString(), 10, 55);
        doc.text("Broj narudžbe:", 100, 35);
        doc.text(order.order_number.toString(), 145, 35);
        doc.text("Datum ispisa:", 100, 40);
        doc.text(
          moment(new Date())
            .format("Do MMMM YYYY")
            .toString() + ". god.",
          145,
          40
        );
        doc.text("Mjesto izdavanja:", 100, 45);
        doc.text(order.account_city, 145, 45);
        doc.autoTable({
          startY: 65,
          tableLineWidth: 0.2,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 11,
            fillColor: [240, 240, 240],
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "center", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text: "Narudžba broj " + order.order_number,
            },
          ],
        });
        doc.text(
          "Molimo fakturišite na: ",
          10,
          doc.autoTable.previous.finalY + 7
        );
        doc.text(order.account_name, 10, doc.autoTable.previous.finalY + 12);
        doc.text(order.account_address, 10, doc.autoTable.previous.finalY + 17);
        doc.text(order.account_city, 10, doc.autoTable.previous.finalY + 22);
        doc.text(order.account_country, 10, doc.autoTable.previous.finalY + 27);
        doc.text("Trans. račun: ", 10, doc.autoTable.previous.finalY + 32);
        doc.text(
          order.account_main_bank_account,
          31,
          doc.autoTable.previous.finalY + 32
        );
        if (order.delivery === "company") {
          doc.text(
            "Isporuka na adresu: ",
            120,
            doc.autoTable.previous.finalY + 7
          );
          doc.text(order.account_name, 120, doc.autoTable.previous.finalY + 12);
          doc.text(
            order.account_address,
            120,
            doc.autoTable.previous.finalY + 17
          );
          doc.text(order.account_city, 120, doc.autoTable.previous.finalY + 22);
          doc.text(
            order.account_country,
            120,
            doc.autoTable.previous.finalY + 27
          );
        }
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 37,
          tableLineWidth: 0.15,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
            cellPadding: 1,
          },
          theme: "plain",
          showFoot: "never",
          columnStyles: {
            0: { halign: "left", valign: "top", fillColor: [255, 255, 255] },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            [
              {
                content: "Napomena: " + order.note,
              },
            ],
          ],
        });
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 5,
          tableLineWidth: 0.15,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "lastPage",
          columnStyles: {
            0: { halign: "center", valign: "top" },
            1: { halign: "left", valign: "top" },
            2: { halign: "center", valign: "top", cellWidth: 20 },
            3: { halign: "center", valign: "top", cellWidth: 20 },
          },
          margin: { top: 10, left: 10, right: 10, bottom: 30 },
          head: [
            [
              {
                content: "#",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Naziv i opis usluge/robe za isporuku",
                styles: {
                  halign: "left",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "JM",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Količina",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
            ],
          ],
          body: order.artikli.map((x, index) => {
            return [
              (index + 1).toString(),
              x.naziv.toString() + "\n" + x.opis.toString(),
              x.jedinica_mjere.toString(),
              i18n.n(parseFloat(x.kom).toFixed(2)),
            ];
          }),
        });
        var footer_start_position = doc.autoTable.previous.finalY + 14;
        if (footer_start_position > 265) {
          doc.addPage();
          footer_start_position = 20;
        }

        if (print_pecat && stamp !== null) {
          var s_width = doc.getImageProperties(stamp).width;
          var s_height = doc.getImageProperties(stamp).height;
          var s_aspect = s_width / s_height;
          s_width = 30 * s_aspect;
          doc.addImage(
            stamp,
            "png",
            78,
            footer_start_position + 1,
            s_width,
            30,
            "pecat"
          );
        }

        doc.text("M.P", 75, footer_start_position + 16);

        if (print_potpis && signature !== null) {
          var p_width = doc.getImageProperties(signature).width;
          var p_height = doc.getImageProperties(signature).height;
          var p_aspect = p_width / p_height;
          p_width = 12 * p_aspect;
          doc.addImage(
            signature,
            "png",
            135,
            footer_start_position + 6,
            p_width,
            12
          );
        }

        doc.text(
          "______________________________",
          145,
          footer_start_position + 16
        );

        doc.text(
          typeof order_account_signatory !== "undefined" &&
            order.account_signatory !== null
            ? order.account_signatory
            : "",
          145,
          doc.autoTable.previous.finalY + 30
        );

        var numOfPages = doc.internal.getNumberOfPages();
        for (var i = 1; i <= numOfPages; i++) {
          doc.setPage(i);
          var footer_start = 5;
          if (logo !== null) {
            var f_width = doc.getImageProperties(logo).width;
            var f_height = doc.getImageProperties(logo).height;
            var f_aspect = f_width / f_height;
            f_width = 7 * f_aspect;
            doc.addImage(logo, "JPEG", 10, 297 - 18, f_width, 7);
            footer_start += f_width + 10;
          }
          doc.setFontSize(8);
          doc.setTextColor(66, 75, 84);
          if (order.document_footer !== null)
            doc.text(order.document_footer, footer_start, 297 - 17);
          QRCode.toDataURL(
            "Narudžba broj " +
            order.order_number +
            " , datum ispisa " +
            moment(new Date())
              .local()
              .format("L"),
            function (err, url) {
              doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
            }
          );
          doc.text(
            "Stranica " + String(i) + " od " + numOfPages,
            210 - 30,
            297 - 5
          );
          doc.setFontSize(6);
          doc.text(
            "Ovaj dokument je kreiran upotrebom SABIRA™ poslovne platforme. Za više informacija posjetite SABIRA.BA",
            10,
            297 - 5
          );
        }
        resolve({
          raw_doc: doc,
          filename: "narudžba_" + order.order_number + ".pdf",
          content: doc.output(),
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  generate_wo_pdf(wo) {
    return new Promise((resolve, reject) => {
      try {
        var logo = wo.logo;
        const doc = new jspdf({
          orientation: "p",
          unit: "mm",
          format: "a4",
          putOnlyUsedFonts: true,
        });
        // header start
        var header_start = 5;
        if (logo !== null) {
          var i_width = doc.getImageProperties(logo).width;
          var i_height = doc.getImageProperties(logo).height;
          var i_aspect = i_width / i_height;
          i_width = 11 * i_aspect;
          doc.addImage(logo, "JPEG", 10, 10, i_width, 11);
          header_start += i_width + 10;
        }
        doc.setFont("Roboto-Regular");
        doc.setFontSize(9);

        if (wo.document_header !== null) {
          doc.text(wo.document_header, header_start, 13);
        }
        // end header
        doc.setFontSize(10);
        doc.text(wo.naziv.toString(), 10, 35);
        doc.text(wo.adresa != null ? wo.adresa.toString() : null, 10, 40);
        doc.text(wo.opstina.toString() + ", " + wo.drzava, 10, 45);
        if (wo.idbroj > 0) doc.text("ID Broj: " + wo.idbroj.toString(), 10, 50);
        if (wo.pdvbroj > 0)
          doc.text("PDV Broj: " + wo.pdvbroj.toString(), 10, 55);
        doc.text("Broj radnog naloga:", 100, 35);
        doc.text(wo.wo_number.toString(), 145, 35);
        doc.text("Datum ispisa:", 100, 40);
        doc.text(
          moment(new Date())
            .format("Do MMMM YYYY")
            .toString() + ". god.",
          145,
          40
        );
        doc.text("Mjesto izdavanja:", 100, 45);
        doc.text(wo.account_city, 145, 45);
        doc.autoTable({
          startY: 65,
          tableLineWidth: 0.2,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 11,
            fillColor: [240, 240, 240],
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "center", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text: "Radni nalog broj " + wo.wo_number,
            },
          ],
        });
        doc.text("Vremenski period: ", 10, doc.autoTable.previous.finalY + 8);
        doc.text(
          moment(new Date(wo.start_date))
            .format("L")
            .toString() +
          ". god." +
          " - ",
          40,
          doc.autoTable.previous.finalY + 8
        );
        if (wo.completion_date != null)
          doc.text(
            moment(new Date(wo.completion_date))
              .format("L")
              .toString() + ". god.",
            69,
            doc.autoTable.previous.finalY + 8
          );
        doc.text(
          "Status radnog naloga: " + wo.status + ".",
          10,
          doc.autoTable.previous.finalY + 13
        );
        doc.text(
          "Realizacija: " +
          wo.status_percent.toFixed(2).replace(".", ",") +
          "%.",
          10,
          doc.autoTable.previous.finalY + 18
        );
        doc.text(
          "Izvršilac: " +
          wo.employee_name +
          "," +
          " " +
          wo.employee_position +
          ".",
          10,
          doc.autoTable.previous.finalY + 23
        );
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 28,
          tableLineWidth: 0.2,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 11,
            fillColor: [240, 240, 240],
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "left", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text: "Kratki opis posla za koji je radni nalog izdat",
            },
          ],
        });
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 0,
          tableLineWidth: 0.15,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "left", valign: "middle", fillColor: [255, 255, 255] },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text: wo.work_desc,
            },
          ],
        });
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 5,
          tableLineWidth: 0.2,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 11,
            fillColor: [240, 240, 240],
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "left", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text: "Lista materijala i radnih sati",
            },
          ],
        });
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 0,
          tableLineWidth: 0.15,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "lastPage",
          columnStyles: {
            0: { halign: "center", valign: "top" },
            1: { halign: "left", valign: "top" },
            2: { halign: "center", valign: "top", cellWidth: 20 },
            3: { halign: "center", valign: "top", cellWidth: 20 },
          },
          margin: { top: 10, left: 10, right: 10, bottom: 30 },
          head: [
            [
              {
                content: "#",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Naziv i opis usluge/robe",
                styles: {
                  halign: "left",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "JM",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Količina",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
            ],
          ],
          body: wo.artikli.map((x, index) => {
            return [
              (index + 1).toString(),
              x.naziv.toString() + "\n" + x.opis.toString(),
              x.jedinica_mjere.toString(),
              i18n.n(parseFloat(x.kom).toFixed(2)),
            ];
          }),
        });
        var footer_start_position = doc.autoTable.previous.finalY + 14;
        if (footer_start_position > 265) {
          doc.addPage();
          footer_start_position = 20;
        }
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          10,
          footer_start_position + 1
        );
        doc.setFontSize(9);
        doc.text("Potpis izvršioca", 21, footer_start_position + 5);
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          82,
          footer_start_position + 1
        );
        doc.setFontSize(9);
        doc.text("Ovjerio", 100, footer_start_position + 5);
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          155,
          footer_start_position + 1
        );
        doc.setFontSize(9);
        doc.text("Klijent", 173, footer_start_position + 5);

        var numOfPages = doc.internal.getNumberOfPages();
        for (var i = 1; i <= numOfPages; i++) {
          doc.setPage(i);
          var footer_start = 5;
          if (logo !== null) {
            var f_width = doc.getImageProperties(logo).width;
            var f_height = doc.getImageProperties(logo).height;
            var f_aspect = f_width / f_height;
            f_width = 7 * f_aspect;
            doc.addImage(logo, "JPEG", 10, 297 - 18, f_width, 7);
            footer_start += f_width + 10;
          }
          doc.setFontSize(8);
          doc.setTextColor(66, 75, 84);
          if (wo.document_footer !== null)
            doc.text(wo.document_footer, footer_start, 297 - 17);
          QRCode.toDataURL(
            "Radni nalog broj " +
            wo.wo_number +
            " , datum ispisa " +
            moment(new Date())
              .local()
              .format("L"),
            function (err, url) {
              doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
            }
          );
          doc.text(
            "Stranica " + String(i) + " od " + numOfPages,
            210 - 30,
            297 - 5
          );
          doc.setFontSize(6);
          doc.text(
            "Ovaj dokument je kreiran upotrebom SABIRA™ poslovne platforme. Za više informacija posjetite SABIRA.BA",
            10,
            297 - 5
          );
        }
        resolve({
          raw_doc: doc,
          filename: "radni_nalog_" + wo.wo_number + ".pdf",
          content: doc.output(),
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  generate_dispatch_note_pdf(dn) {
    return new Promise((resolve, reject) => {
      try {
        var logo = dn.logo;
        const doc = new jspdf({
          orientation: "p",
          unit: "mm",
          format: "a4",
          putOnlyUsedFonts: true,
        });
        // header start
        var header_start = 5;
        if (logo !== null) {
          var i_width = doc.getImageProperties(logo).width;
          var i_height = doc.getImageProperties(logo).height;
          var i_aspect = i_width / i_height;
          i_width = 11 * i_aspect;
          doc.addImage(logo, "JPEG", 10, 10, i_width, 11);
          header_start += i_width + 10;
        }
        doc.setFont("Roboto-Regular");
        doc.setFontSize(9);

        if (dn.document_header !== null) {
          doc.text(dn.document_header, header_start, 13);
        }
        // end header

        doc.setFontSize(10);
        doc.text(dn.naziv.toString(), 10, 35);
        doc.text(dn.adresa != null ? dn.adresa.toString() : null, 10, 40);
        doc.text(dn.opstina.toString() + ", " + dn.drzava, 10, 45);
        if (dn.idbroj > 0) doc.text("ID Broj: " + dn.idbroj.toString(), 10, 50);
        if (dn.pdvbroj > 0)
          doc.text("PDV Broj: " + dn.pdvbroj.toString(), 10, 55);
        doc.text("Broj otpremnice:", 100, 35);
        doc.text(dn.dispatch_note_number.toString(), 145, 35);
        doc.text("Broj fakture:", 100, 40);
        doc.text(dn.broj.toString(), 145, 40);
        doc.text("Datum ispisa:", 100, 45);
        doc.text(
          moment(new Date())
            .format("Do MMMM YYYY")
            .toString() + ". god.",
          145,
          45
        );
        doc.text("Datum otpremnice:", 100, 50);
        doc.text(
          moment(new Date(dn.datum))
            .format("Do MMMM YYYY")
            .toString() + ". god.",
          145,
          50
        );
        doc.text("Mjesto izdavanja:", 100, 55);
        doc.text(dn.account_city, 145, 55);
        doc.autoTable({
          startY: 65,
          tableLineWidth: 0.2,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 11,
            fillColor: [240, 240, 240],
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "center", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text: "Otpremnica broj " + dn.dispatch_note_number,
            },
          ],
        });
        doc.text("Šifra magacina: ", 10, doc.autoTable.previous.finalY + 9);
        doc.text(dn.warehouse_wh_code, 37, doc.autoTable.previous.finalY + 9);
        doc.text("Magacin: ", 10, doc.autoTable.previous.finalY + 14);
        doc.text(dn.warehouse_name, 37, doc.autoTable.previous.finalY + 14);
        doc.text("Adresa: ", 10, doc.autoTable.previous.finalY + 19);
        doc.text(
          dn.warehouse_address +
          ", " +
          dn.warehouse_zip +
          " " +
          dn.warehouse_city +
          ", " +
          dn.warehouse_country,
          37,
          doc.autoTable.previous.finalY + 19
        );
        doc.text("Magacioner: ", 10, doc.autoTable.previous.finalY + 24);
        doc.text(
          dn.warehouse_employee_name,
          37,
          doc.autoTable.previous.finalY + 24
        );

        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 30,
          tableLineWidth: 0.15,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "lastPage",
          columnStyles: {
            0: { halign: "center", valign: "top", cellWidth: 8 },
            1: { halign: "left", valign: "top", cellWidth: 70 },
            2: { halign: "center", valign: "top" },
            3: { halign: "center", valign: "top" },
            4: { halign: "right", valign: "top", cellWidth: 23 },
            5: { halign: "right", valign: "top", cellWidth: 13 },
            6: { halign: "right", valign: "top", cellWidth: 23 },
            7: { halign: "right", valign: "top", cellWidth: 23 },
          },
          margin: { top: 10, left: 10, right: 10, bottom: 30 },
          head: [
            [
              {
                content: "#",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Naziv i opis usluge/robe",
                styles: {
                  halign: "left",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "JM",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Kol",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Cijena/JM bez PDV-a",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "PDV %",
                styles: {
                  cellWidth: "auto",
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "PDV",
                styles: {
                  cellWidth: "auto",
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "Ukupno bez PDV-a",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
            ],
          ],
          body: dn.artikli.map((x, index) => {
            return [
              (index + 1).toString(),
              x.naziv.toString() + "\n" + x.opis.toString(),
              x.jedinica_mjere.toString(),
              i18n.n(parseFloat(x.kom).toFixed(2)),
              x.rabat > 0
                ? i18n.n(parseFloat(x.cijena_rabat).toFixed(2))
                : i18n.n(parseFloat(x.cijena).toFixed(2)),
              Math.round(x.pdv_postotak).toString() + "%",
              i18n.n(parseFloat(x.pdv_total, 2).toFixed(2)),
              i18n.n(parseFloat(x.ukupno).toFixed(2)),
            ];
          }),
        });

        var footer_start_position = doc.autoTable.previous.finalY;
        var is_new_page = false;
        if (footer_start_position > 247) {
          is_new_page = true;
          doc.addPage();
          footer_start_position = 20;
        }
        doc.autoTable({
          startY: footer_start_position + 1,
          tableLineWidth: 0,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "never",
          columnStyles: {
            0: { halign: "left", valign: "middle" },
            1: { halign: "right", valign: "middle" },
            2: { halign: "right", valign: "middle", cellWidth: 30 },
          },
          margin: {
            top: is_new_page ? 10 : 20,
            left: 10,
            right: 10,
            bottom: 30,
          },
          body: [
            [
              "Slovima: " +
              this.convertToWords(
                parseFloat(this.grand_total_dn(dn)).toFixed(2)
              ),
              "Ukupno bez PDV-a",
              i18n.n(parseFloat(this.dn_total(dn)).toFixed(2)),
            ],
            [
              {
                content: "",
                rowSpan: 2,
                styles: {
                  halign: "left",
                  valign: "top",
                  cellWidth: "auto",
                },
              },
              {
                content: "PDV",
                styles: {
                  halign: "right",
                },
              },
              i18n.n(parseFloat(this.tax_total_dn(dn)).toFixed(2)),
            ],
            [
              {
                content: "Za uplatiti",
                styles: {
                  halign: "right",
                  cellWidth: "wrap",
                  lineWidth: {
                    top: 0.3,
                    botom: 0.3,
                  },
                  lineColor: [0, 0, 0],
                },
              },
              {
                content:
                  "KM   " + i18n.n(parseFloat(this.grand_total(dn)).toFixed(2)),
                styles: {
                  halign: "right",
                  lineWidth: {
                    top: 0.3,
                    botom: 0.3,
                  },
                  lineColor: [0, 0, 0],
                },
              },
            ],
          ],
        });
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          10,
          doc.autoTable.previous.finalY + 20
        );
        doc.setFontSize(9);
        doc.text("Izdao", 28, doc.autoTable.previous.finalY + 24);
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          82,
          doc.autoTable.previous.finalY + 20
        );
        doc.setFontSize(9);
        doc.text("Kontrolisao", 96, doc.autoTable.previous.finalY + 24);
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          155,
          doc.autoTable.previous.finalY + 20
        );
        doc.setFontSize(9);
        doc.text("Primio", 173, doc.autoTable.previous.finalY + 24);

        var numOfPages = doc.internal.getNumberOfPages();
        for (var i = 1; i <= numOfPages; i++) {
          doc.setPage(i);
          var footer_start = 5;
          if (logo !== null) {
            var f_width = doc.getImageProperties(logo).width;
            var f_height = doc.getImageProperties(logo).height;
            var f_aspect = f_width / f_height;
            f_width = 7 * f_aspect;
            doc.addImage(logo, "JPEG", 10, 297 - 18, f_width, 7);
            footer_start += f_width + 10;
          }
          doc.setFontSize(8);
          doc.setTextColor(66, 75, 84);
          if (dn.document_footer !== null)
            doc.text(dn.document_footer, footer_start, 297 - 17);
          QRCode.toDataURL(
            "otpremnica_" + dn.dispatch_note_number + ".pdf",
            function (err, url) {
              doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
            }
          );
          doc.text(
            "Stranica " + String(i) + " od " + numOfPages,
            210 - 30,
            297 - 5
          );
          doc.setFontSize(6);
          doc.text(
            "Ovaj dokument je kreiran upotrebom SABIRA™ poslovne platforme. Za više informacija posjetite SABIRA.BA",
            10,
            297 - 5
          );
        }
        resolve({
          raw_doc: doc,
          filename: "otpremnica_" + dn.dispatch_note_number + ".pdf",
          content: doc.output(),
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  generate_re_pdf(re) {
    return new Promise((resolve, reject) => {
      try {
        var logo = re.logo;
        const doc = new jspdf({
          orientation: "p",
          unit: "mm",
          format: "a4",
          putOnlyUsedFonts: true,
        });
        // header start
        var header_start = 5;
        if (logo !== null) {
          var i_width = doc.getImageProperties(logo).width;
          var i_height = doc.getImageProperties(logo).height;
          var i_aspect = i_width / i_height;
          i_width = 11 * i_aspect;
          doc.addImage(logo, "JPEG", 10, 10, i_width, 11);
          header_start += i_width + 10;
        }
        doc.setFont("Roboto-Regular");
        doc.setFontSize(9);

        if (re.document_header !== null) {
          doc.text(re.document_header, header_start, 13);
        }
        // end header

        doc.setFontSize(10);
        doc.text(re.naziv.toString(), 10, 35);
        doc.text(re.adresa != null ? re.adresa.toString() : null, 10, 40);
        doc.text(re.opstina.toString() + ", " + re.drzava, 10, 45);
        if (re.idbroj > 0) doc.text("ID Broj: " + re.idbroj.toString(), 10, 50);
        if (re.pdvbroj > 0)
          doc.text("PDV Broj: " + re.pdvbroj.toString(), 10, 55);
        doc.text("Broj povrata:", 100, 35);
        doc.text(re.returns_number.toString(), 145, 35);
        doc.text("Datum ispisa:", 100, 40);
        doc.text(
          moment(new Date())
            .format("Do MMMM YYYY")
            .toString() + ". god.",
          145,
          40
        );
        doc.text("Mjesto izdavanja:", 100, 45);
        doc.text(re.account_city, 145, 45);
        doc.autoTable({
          startY: 57,
          tableLineWidth: 0.2,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 11,
            fillColor: [240, 240, 240],
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "center", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text: "Povrat broj " + re.returns_number,
            },
          ],
        });
        doc.text("Šifra magacina: ", 10, doc.autoTable.previous.finalY + 9);
        doc.text(re.warehouse_wh_code, 37, doc.autoTable.previous.finalY + 9);
        doc.text("Magacin: ", 10, doc.autoTable.previous.finalY + 14);
        doc.text(re.warehouse_name, 37, doc.autoTable.previous.finalY + 14);
        doc.text("Adresa: ", 10, doc.autoTable.previous.finalY + 19);
        doc.text(
          re.warehouse_address +
          ", " +
          re.warehouse_zip +
          " " +
          re.warehouse_city +
          ", " +
          re.warehouse_country,
          37,
          doc.autoTable.previous.finalY + 19
        );
        doc.text("Magacioner: ", 10, doc.autoTable.previous.finalY + 24);
        doc.text(
          re.warehouse_employee_name,
          37,
          doc.autoTable.previous.finalY + 24
        );
        doc.text(
          "Povrat niže navedene robe izvršen je iz razloga: " +
          re.returns_condition +
          ".",
          10,
          doc.autoTable.previous.finalY + 32
        );
        doc.text(
          "Status robe za povrat je: " + re.returns_status + ".",
          10,
          doc.autoTable.previous.finalY + 37
        );

        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 42,
          tableLineWidth: 0.15,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
            cellPadding: 1,
          },
          theme: "plain",
          showFoot: "never",
          columnStyles: {
            0: { halign: "left", valign: "top", fillColor: [255, 255, 255] },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            [
              {
                content:
                  "Dodatne informacije u vezi povrata robe: " +
                  re.additional_info,
              },
            ],
          ],
        });
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 5,
          tableLineWidth: 0.15,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "lastPage",
          columnStyles: {
            0: { halign: "center", valign: "top", cellWidth: 8 },
            1: { halign: "left", valign: "top", cellWidth: 70 },
            2: { halign: "center", valign: "top" },
            3: { halign: "center", valign: "top" },
            4: { halign: "right", valign: "top", cellWidth: 23 },
            5: { halign: "right", valign: "top", cellWidth: 13 },
            6: { halign: "right", valign: "top", cellWidth: 23 },
            7: { halign: "right", valign: "top", cellWidth: 23 },
          },
          margin: { top: 10, left: 10, right: 10, bottom: 30 },
          head: [
            [
              {
                content: "#",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Naziv i opis usluge/robe",
                styles: {
                  halign: "left",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "JM",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Količina",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Cijena/JM bez PDV-a",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "PDV %",
                styles: {
                  cellWidth: "auto",
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "PDV",
                styles: {
                  cellWidth: "auto",
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "Ukupno bez PDV-a",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
            ],
          ],
          body: re.artikli.map((x, index) => {
            return [
              (index + 1).toString(),
              x.naziv.toString() + "\n" + x.opis.toString(),
              x.jedinica_mjere.toString(),
              i18n.n(parseFloat(x.kom).toFixed(2)),
              x.rabat > 0
                ? i18n.n(parseFloat(x.cijena_rabat).toFixed(2))
                : i18n.n(parseFloat(x.cijena).toFixed(2)),
              Math.round(x.pdv_postotak).toString() + "%",
              i18n.n(parseFloat(x.pdv_total, 2).toFixed(2)),
              i18n.n(parseFloat(x.ukupno).toFixed(2)),
            ];
          }),
        });

        var footer_start_position = doc.autoTable.previous.finalY;
        var is_new_page = false;
        if (footer_start_position > 247) {
          is_new_page = true;
          doc.addPage();
          footer_start_position = 20;
        }
        doc.autoTable({
          startY: footer_start_position + 1,
          tableLineWidth: 0,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "never",
          columnStyles: {
            0: { halign: "left", valign: "middle" },
            1: { halign: "right", valign: "middle" },
            2: { halign: "right", valign: "middle", cellWidth: 30 },
          },
          margin: {
            top: is_new_page ? 10 : 20,
            left: 10,
            right: 10,
            bottom: 30,
          },
          body: [
            [
              "Slovima: " +
              this.convertToWords(
                parseFloat(this.grand_total_re(re)).toFixed(2)
              ),
              "Ukupno bez PDV-a",
              i18n.n(parseFloat(this.re_total(re)).toFixed(2)),
            ],
            [
              {
                content: "",
                rowSpan: 2,
                styles: {
                  halign: "left",
                  valign: "top",
                  cellWidth: "auto",
                },
              },
              {
                content: "PDV",
                styles: {
                  halign: "right",
                },
              },
              i18n.n(parseFloat(this.tax_total_re(re)).toFixed(2)),
            ],
            [
              {
                content: "Vrijednost povrata",
                styles: {
                  halign: "right",
                  cellWidth: "wrap",
                  lineWidth: {
                    top: 0.3,
                    botom: 0.3,
                  },
                  lineColor: [0, 0, 0],
                },
              },
              {
                content:
                  "KM   " + i18n.n(parseFloat(this.grand_total(re)).toFixed(2)),
                styles: {
                  halign: "right",
                  lineWidth: {
                    top: 0.3,
                    botom: 0.3,
                  },
                  lineColor: [0, 0, 0],
                },
              },
            ],
          ],
        });
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          10,
          doc.autoTable.previous.finalY + 20
        );
        doc.setFontSize(9);
        doc.text("Izdao", 28, doc.autoTable.previous.finalY + 24);
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          82,
          doc.autoTable.previous.finalY + 20
        );
        doc.setFontSize(9);
        doc.text("Kontrolisao", 96, doc.autoTable.previous.finalY + 24);
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          155,
          doc.autoTable.previous.finalY + 20
        );
        doc.setFontSize(9);
        doc.text("Primio", 173, doc.autoTable.previous.finalY + 24);

        var numOfPages = doc.internal.getNumberOfPages();
        for (var i = 1; i <= numOfPages; i++) {
          doc.setPage(i);
          var footer_start = 5;
          if (logo !== null) {
            var f_width = doc.getImageProperties(logo).width;
            var f_height = doc.getImageProperties(logo).height;
            var f_aspect = f_width / f_height;
            f_width = 7 * f_aspect;
            doc.addImage(logo, "JPEG", 10, 297 - 18, f_width, 7);
            footer_start += f_width + 10;
          }
          doc.setFontSize(8);
          doc.setTextColor(66, 75, 84);
          if (re.document_footer !== null)
            doc.text(re.document_footer, footer_start, 297 - 17);
          QRCode.toDataURL("povrat_" + re.returns_number + ".pdf", function (
            err,
            url
          ) {
            doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
          });
          doc.text(
            "Stranica " + String(i) + " od " + numOfPages,
            210 - 30,
            297 - 5
          );
          doc.setFontSize(6);
          doc.text(
            "Ovaj dokument je kreiran upotrebom SABIRA™ poslovne platforme. Za više informacija posjetite SABIRA.BA",
            10,
            297 - 5
          );
        }
        resolve({
          raw_doc: doc,
          filename: "povrat_" + re.returns_number + ".pdf",
          content: doc.output(),
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  generate_swo_pdf(swo) {
    return new Promise((resolve, reject) => {
      try {
        var logo = swo.logo;
        const doc = new jspdf({
          orientation: "p",
          unit: "mm",
          format: "a4",
          putOnlyUsedFonts: true,
        });
        // header start
        var header_start = 5;
        if (logo !== null) {
          var i_width = doc.getImageProperties(logo).width;
          var i_height = doc.getImageProperties(logo).height;
          var i_aspect = i_width / i_height;
          i_width = 11 * i_aspect;
          doc.addImage(logo, "JPEG", 10, 10, i_width, 11);
          header_start += i_width + 10;
        }
        doc.setFont("Roboto-Regular");
        doc.setFontSize(9);

        if (swo.document_header !== null) {
          doc.text(swo.document_header, header_start, 13);
        }
        // end header

        doc.setFontSize(10);
        doc.text("Broj otpisa:", 10, 35);
        doc.text(swo.swo_number.toString(), 45, 35);
        doc.text("Datum ispisa:", 10, 40);
        doc.text(
          moment(new Date())
            .format("Do MMMM YYYY")
            .toString() + ". god.",
          45,
          40
        );
        doc.text("Mjesto izdavanja:", 10, 45);
        doc.text(swo.account_city, 45, 45);
        doc.autoTable({
          startY: 52,
          tableLineWidth: 0.2,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 11,
            fillColor: [240, 240, 240],
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "center", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text: "Otpis broj " + swo.swo_number,
            },
          ],
        });
        doc.text("Šifra magacina: ", 10, doc.autoTable.previous.finalY + 9);
        doc.text(swo.warehouse_wh_code, 37, doc.autoTable.previous.finalY + 9);
        doc.text("Magacin: ", 10, doc.autoTable.previous.finalY + 14);
        doc.text(swo.warehouse_name, 37, doc.autoTable.previous.finalY + 14);
        doc.text("Adresa: ", 10, doc.autoTable.previous.finalY + 19);
        doc.text(
          swo.warehouse_address +
          ", " +
          swo.warehouse_zip +
          " " +
          swo.warehouse_city +
          ", " +
          swo.warehouse_country,
          37,
          doc.autoTable.previous.finalY + 19
        );
        doc.text("Magacioner: ", 10, doc.autoTable.previous.finalY + 24);
        doc.text(
          swo.warehouse_employee_name,
          37,
          doc.autoTable.previous.finalY + 24
        );

        doc.text(
          "Otpis niže navedene robe izvršen je iz razloga: " + swo.reason,
          10,
          doc.autoTable.previous.finalY + 32
        );

        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 37,
          tableLineWidth: 0.15,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
            cellPadding: 1,
          },
          theme: "plain",
          showFoot: "never",
          columnStyles: {
            0: { halign: "left", valign: "top", fillColor: [255, 255, 255] },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            [
              {
                content: "Dodatne informacije u vezi otpisa: " + swo.swo_desc,
              },
            ],
          ],
        });

        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 5,
          tableLineWidth: 0.15,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "lastPage",
          columnStyles: {
            0: { halign: "center", valign: "top", cellWidth: 8 },
            1: { halign: "left", valign: "top", cellWidth: 70 },
            2: { halign: "center", valign: "top" },
            3: { halign: "center", valign: "top" },
            4: { halign: "right", valign: "top", cellWidth: 23 },
            5: { halign: "right", valign: "top", cellWidth: 13 },
            6: { halign: "right", valign: "top", cellWidth: 23 },
            7: { halign: "right", valign: "top", cellWidth: 23 },
          },
          margin: { top: 10, left: 10, right: 10, bottom: 30 },
          head: [
            [
              {
                content: "#",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Naziv i opis usluge/robe",
                styles: {
                  halign: "left",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "JM",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Kol",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Cijena/JM bez PDV-a",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "PDV %",
                styles: {
                  cellWidth: "auto",
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "PDV",
                styles: {
                  cellWidth: "auto",
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "Ukupno bez PDV-a",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
            ],
          ],
          body: swo.artikli.map((x, index) => {
            return [
              (index + 1).toString(),
              x.naziv.toString() + "\n" + x.opis.toString(),
              x.jedinica_mjere.toString(),
              i18n.n(parseFloat(x.kom).toFixed(2)),
              x.rabat > 0
                ? i18n.n(parseFloat(x.cijena_rabat).toFixed(2))
                : i18n.n(parseFloat(x.cijena).toFixed(2)),
              Math.round(x.pdv_postotak).toString() + "%",
              i18n.n(parseFloat(x.pdv_total, 2).toFixed(2)),
              i18n.n(parseFloat(x.ukupno).toFixed(2)),
            ];
          }),
        });

        var footer_start_position = doc.autoTable.previous.finalY;
        var is_new_page = false;
        if (footer_start_position > 247) {
          is_new_page = true;
          doc.addPage();
          footer_start_position = 20;
        }
        doc.autoTable({
          startY: footer_start_position + 1,
          tableLineWidth: 0,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "never",
          columnStyles: {
            0: { halign: "left", valign: "middle" },
            1: { halign: "right", valign: "middle" },
            2: { halign: "right", valign: "middle", cellWidth: 30 },
          },
          margin: {
            top: is_new_page ? 10 : 20,
            left: 10,
            right: 10,
            bottom: 30,
          },
          body: [
            [
              "Slovima: " +
              this.convertToWords(
                parseFloat(this.grand_total_swo(swo)).toFixed(2)
              ),
              "Ukupno bez PDV-a",
              i18n.n(parseFloat(this.swo_total(swo)).toFixed(2)),
            ],
            [
              {
                content: "",
                rowSpan: 2,
                styles: {
                  halign: "left",
                  valign: "top",
                  cellWidth: "auto",
                },
              },
              {
                content: "PDV",
                styles: {
                  halign: "right",
                },
              },
              i18n.n(parseFloat(this.tax_total_swo(swo)).toFixed(2)),
            ],
            [
              {
                content: "Vrijednost otpisa",
                styles: {
                  halign: "right",
                  cellWidth: "wrap",
                  lineWidth: {
                    top: 0.3,
                    botom: 0.3,
                  },
                  lineColor: [0, 0, 0],
                },
              },
              {
                content:
                  "KM   " +
                  i18n.n(parseFloat(this.grand_total(swo)).toFixed(2)),
                styles: {
                  halign: "right",
                  lineWidth: {
                    top: 0.3,
                    botom: 0.3,
                  },
                  lineColor: [0, 0, 0],
                },
              },
            ],
          ],
        });
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          10,
          doc.autoTable.previous.finalY + 20
        );
        doc.setFontSize(9);
        doc.text(
          "Predsjednik komisije",
          18,
          doc.autoTable.previous.finalY + 24
        );
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          82,
          doc.autoTable.previous.finalY + 20
        );
        doc.setFontSize(9);
        doc.text("Član komisije", 95, doc.autoTable.previous.finalY + 24);
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          155,
          doc.autoTable.previous.finalY + 20
        );
        doc.setFontSize(9);
        doc.text("Član komisije", 169, doc.autoTable.previous.finalY + 24);

        var numOfPages = doc.internal.getNumberOfPages();
        for (var i = 1; i <= numOfPages; i++) {
          doc.setPage(i);
          var footer_start = 5;
          if (logo !== null) {
            var f_width = doc.getImageProperties(logo).width;
            var f_height = doc.getImageProperties(logo).height;
            var f_aspect = f_width / f_height;
            f_width = 7 * f_aspect;
            doc.addImage(logo, "JPEG", 10, 297 - 18, f_width, 7);
            footer_start += f_width + 10;
          }
          doc.setFontSize(8);
          doc.setTextColor(66, 75, 84);
          if (swo.document_footer !== null)
            doc.text(swo.document_footer, footer_start, 297 - 17);
          QRCode.toDataURL(swo.swo_number + ".pdf", function (err, url) {
            doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
          });
          doc.text(
            "Stranica " + String(i) + " od " + numOfPages,
            210 - 30,
            297 - 5
          );
          doc.setFontSize(6);
          doc.text(
            "Ovaj dokument je kreiran upotrebom SABIRA™ poslovne platforme. Za više informacija posjetite SABIRA.BA",
            10,
            297 - 5
          );
        }
        resolve({
          raw_doc: doc,
          filename: swo.swo_number + ".pdf",
          content: doc.output(),
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  generate_inv_pdf(inv) {
    return new Promise((resolve, reject) => {
      try {
        var logo = inv.logo;
        const doc = new jspdf({
          orientation: "p",
          unit: "mm",
          format: "a4",
          putOnlyUsedFonts: true,
        });
        // header start
        var header_start = 5;
        if (logo !== null) {
          var i_width = doc.getImageProperties(logo).width;
          var i_height = doc.getImageProperties(logo).height;
          var i_aspect = i_width / i_height;
          i_width = 11 * i_aspect;
          doc.addImage(logo, "JPEG", 10, 10, i_width, 11);
          header_start += i_width + 10;
        }
        doc.setFont("Roboto-Regular");
        doc.setFontSize(9);

        if (inv.document_header !== null) {
          doc.text(inv.document_header, header_start, 13);
        }
        // end header

        doc.setFontSize(10);
        doc.text("Datum ispisa:", 10, 35);
        doc.text(
          moment(new Date())
            .format("Do MMMM YYYY")
            .toString() + ". god.",
          45,
          35
        );
        doc.text("Mjesto izdavanja:", 10, 40);
        doc.text(inv.account_city, 45, 40);
        doc.autoTable({
          startY: 47,
          tableLineWidth: 0.2,
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 11,
            fillColor: [240, 240, 240],
          },
          theme: "plain",
          columnStyles: {
            0: { halign: "center", valign: "middle" },
          },
          margin: { top: 0, left: 10, right: 10 },
          body: [
            {
              text:
                "Popis zaliha na dan " +
                moment(new Date(inv.inv_date))
                  .format("Do MMMM YYYY")
                  .toString() +
                ". god.",
            },
          ],
        });
        doc.text("Šifra magacina: ", 10, doc.autoTable.previous.finalY + 9);
        doc.text(inv.wh_code, 37, doc.autoTable.previous.finalY + 9);
        doc.text("Magacin: ", 10, doc.autoTable.previous.finalY + 14);
        doc.text(inv.warehouse_name, 37, doc.autoTable.previous.finalY + 14);
        doc.text("Adresa: ", 10, doc.autoTable.previous.finalY + 19);
        doc.text(
          inv.warehouse_address +
          ", " +
          inv.warehouse_zip +
          " " +
          inv.warehouse_city +
          ", " +
          inv.warehouse_country,
          37,
          doc.autoTable.previous.finalY + 19
        );
        doc.text("Magacioner: ", 10, doc.autoTable.previous.finalY + 24);
        doc.text(inv.employee_name, 37, doc.autoTable.previous.finalY + 24);

        doc.text(
          "Tip popisa: " + inv.inventory_type,
          10,
          doc.autoTable.previous.finalY + 32
        );
        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 38,
          tableLineWidth: 0.15,
          rowPageBreak: "avoid",
          styles: {
            font: "Roboto-Regular",
            lineWidth: 0.15,
            fontSize: 9,
          },
          theme: "plain",
          showFoot: "lastPage",
          columnStyles: {
            0: { halign: "center", valign: "top" },
            1: { halign: "left", valign: "top" },
            2: { halign: "left", valign: "top" },
            3: { halign: "right", valign: "top", cellWidth: 27 },
            4: { halign: "right", valign: "top", cellWidth: 27 },
            5: { halign: "right", valign: "top", cellWidth: 27 },
          },
          margin: { top: 10, left: 10, right: 10, bottom: 30 },
          head: [
            [
              {
                content: "#",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "Šifra",
                styles: {
                  halign: "left",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Artikal",
                styles: {
                  halign: "left",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                  cellWidth: "wrap",
                },
              },
              {
                content: "Stanje zalihe",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "Popisana količina",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
              {
                content: "Razlika",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fillColor: [240, 240, 240],
                },
              },
            ],
          ],
          body: inv.artikli.map((x, index) => {
            return [
              (index + 1).toString(),
              x.article_code.toString(),
              x.article_name.toString() + "\n" + x.article_desc.toString(),
              i18n.n(parseFloat(x.total_stock).toFixed(2)),
              i18n.n(parseFloat(x.inventory_quantity).toFixed(2)),
              i18n.n(parseFloat(x.inventory_difference).toFixed(2)),
            ];
          }),
        });
        var footer_start_position = doc.autoTable.previous.finalY;
        // var is_new_page = false;
        if (footer_start_position > 247) {
          // is_new_page = true;
          doc.addPage();
          footer_start_position = 20;
        }
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          10,
          footer_start_position + 13
        );
        doc.setFontSize(9);
        doc.text("Predsjednik komisije", 18, footer_start_position + 17);
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          82,
          footer_start_position + 13
        );
        doc.setFontSize(9);
        doc.text("Član komisije", 95, footer_start_position + 17);
        doc.setFontSize(8);
        doc.text(
          "___________________________________",
          155,
          footer_start_position + 13
        );
        doc.setFontSize(9);
        doc.text("Član komisije", 169, footer_start_position + 17);

        var numOfPages = doc.internal.getNumberOfPages();
        for (var i = 1; i <= numOfPages; i++) {
          doc.setPage(i);
          var footer_start = 5;
          if (logo !== null) {
            var f_width = doc.getImageProperties(logo).width;
            var f_height = doc.getImageProperties(logo).height;
            var f_aspect = f_width / f_height;
            f_width = 7 * f_aspect;
            doc.addImage(logo, "JPEG", 10, 297 - 18, f_width, 7);
            footer_start += f_width + 10;
          }
          doc.setFontSize(8);
          doc.setTextColor(66, 75, 84);
          if (inv.document_footer !== null)
            doc.text(inv.document_footer, footer_start, 297 - 17);
          QRCode.toDataURL(
            "Popis zaliha " + moment(new Date(inv.inv_date)).format("L"),
            function (err, url) {
              doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
            }
          );
          doc.text(
            "Stranica " + String(i) + " od " + numOfPages,
            210 - 30,
            297 - 5
          );
          doc.setFontSize(6);
          doc.text(
            "Ovaj dokument je kreiran upotrebom SABIRA™ poslovne platforme. Za više informacija posjetite SABIRA.BA",
            10,
            297 - 5
          );
        }
        resolve({
          raw_doc: doc,
          filename:
            "popis_zaliha_" +
            moment(new Date(inv.inv_date)).format("Do MMMM YYYY") +
            ".pdf",
          content: doc.output(),
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  grand_total(invoice) {
    return invoice.artikli.length
      ? invoice.artikli
        .map((x) => x.total)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  invoice_total(invoice) {
    return invoice.artikli.length
      ? invoice.artikli
        .map((x) => x.ukupno)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  tax_total(invoice) {
    return invoice.artikli.length
      ? invoice.artikli
        .map((x) => x.pdv_total)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  grand_total_ko(ko) {
    return ko.artikli.length
      ? ko.artikli
        .map((x) => x.total)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  ko_total(ko) {
    return ko.artikli.length
      ? ko.artikli
        .map((x) => x.ukupno)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  tax_total_ko(ko) {
    return ko.artikli.length
      ? ko.artikli
        .map((x) => x.pdv_total)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  grand_total_dn(dn) {
    return dn.artikli.length
      ? dn.artikli
        .map((x) => x.total)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  dn_total(dn) {
    return dn.artikli.length
      ? dn.artikli
        .map((x) => x.ukupno)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  tax_total_dn(dn) {
    return dn.artikli.length
      ? dn.artikli
        .map((x) => x.pdv_total)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  grand_total_re(re) {
    return re.artikli.length
      ? re.artikli
        .map((x) => x.total)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  re_total(re) {
    return re.artikli.length
      ? re.artikli
        .map((x) => x.ukupno)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  tax_total_re(re) {
    return re.artikli.length
      ? re.artikli
        .map((x) => x.pdv_total)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  grand_total_swo(swo) {
    return swo.artikli.length
      ? swo.artikli
        .map((x) => x.total)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  swo_total(swo) {
    return swo.artikli.length
      ? swo.artikli
        .map((x) => x.ukupno)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  tax_total_swo(swo) {
    return swo.artikli.length
      ? swo.artikli
        .map((x) => x.pdv_total)
        .reduce((a, b) => {
          return a + b;
        })
      : 0;
  },
  // cutOffDecimals(number, digits) {
  //   const pow = Math.pow(10, digits);
  //   return Math.floor(number * pow) / pow;
  // },
  uplatiti_do_formatiran(invoice) {
    return moment(new Date(invoice.uplatiti_do)).format("Do MMMM YYYY");
  },
  load_user_profile(user_id) {
    if (typeof user_id == "undefined") {
      user_id = store.getters.user.id;
    }
    return new Promise((resolve, reject) => {
      try {
        axios({
          method: "POST",
          url: "/users/get_user",
          data: {
            id: user_id,
          },
        }).then((resp) => {
          var user = resp.data.result;
          user.account_id = resp.data.account_id;
          store
            .dispatch("set_current_user", user)
            .then(() => {
              resolve(user);
            })
            .catch((s_error) => {
              reject(s_error);
            });
        });
      } catch (error) {
        reject(error);
      }
    });
  },
};
